import { singleton } from "tsyringe";
import currentDevice from "current-device";

type DeviceType = "tablet" | "smartphone" | "desktop";

@singleton()
export class Device {
  public getDeviceType(): DeviceType {
    if (currentDevice.tablet()) {
      return "tablet";
    }

    if (currentDevice.mobile()) {
      return "smartphone";
    }

    return "desktop";
  }
}
